/**
 * ModuleSection Component
 * 
 * Groups drill cards by module with header and completion summary
 */

import { DrillProgressCard } from './DrillProgressCard';
import type { ModuleProgress } from '@/services/dashboard-progress';

interface ModuleSectionProps {
  module: ModuleProgress;
}

export function ModuleSection({ module }: ModuleSectionProps) {
  const completedDrills = module.drills.filter(
    d => d.status === 'complete' || d.status === 'mastered'
  ).length;

  return (
    <section className="mb-8">
      {/* Module header */}
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-bold text-gray-900">
            {module.module_name}
          </h2>
          <p className="text-sm text-gray-600">
            {completedDrills} of {module.drills.length} drills completed
          </p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-gray-900">
            {module.completion_percentage}%
          </div>
          <div className="text-xs text-gray-500">complete</div>
        </div>
      </div>

      {/* Drill cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {module.drills.map(drill => (
          <DrillProgressCard key={drill.drill_id} drill={drill} />
        ))}
      </div>
    </section>
  );
}

